import React from "react";
import StoreAgencyListItem from "./storeAgencyListItem";
import "./style.scss";

const StoreAgencyList = (props: any) => {
  const { stores } = props;

  return stores.length ? (
    <div className="stores-list-container">
      {stores.map((store: any) => (
        <StoreAgencyListItem key={store._id} store={store} />
      ))}
    </div>
  ) : (
    <div></div>
  );
};

export default StoreAgencyList;
